(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pfs-package-social-proof"] && !Shopify.designMode) return;
  try {
    function pfsSocialProofTarget(link) {
    const area = document.getElementById(link.dataset.pfsBuyArea);
    if (!area) return null;
    const form = Array.from(area.querySelectorAll('product-form form[id], form.pfs-preorder-form[id]'))
      .find(candidate => candidate.getBoundingClientRect().height > 0 && candidate.getClientRects().length);
    const target = form || area;
    link.setAttribute('href', '#' + target.getAttribute('id'));
    return target;
  }

  document.querySelectorAll('.pfs-package-social-proof [data-pfs-product-cta]').forEach(pfsSocialProofTarget);
  document.addEventListener('click', event => {
    const link = event.target.closest('.pfs-package-social-proof [data-pfs-product-cta]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = pfsSocialProofTarget(link);
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    const headerHeight = Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
      .filter(header => ['sticky', 'fixed'].includes(getComputedStyle(header).position))
      .reduce((height, header) => height + header.getBoundingClientRect().height, 0);
    const top = window.scrollY + target.getBoundingClientRect().top - headerHeight - 48;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pfs-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pfs-share-card')) {
  class PfsShareCard extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.trigger = this.querySelector('.pfs-share-trigger');
      this.menu = this.querySelector('.pfs-share-menu');
      this.status = this.querySelector('.pfs-share-status');
      this.phone = matchMedia('(max-width:749px)');
      this.trigger.addEventListener('click',event => {
        event.stopPropagation();
        if (!this.menu.hidden) return this.close(false);
        this.open(event.detail === 0);
      },opts);
      this.trigger.addEventListener('keydown',event => {
        if (event.key === 'ArrowDown') {event.preventDefault();this.open(true);}
      },opts);
      document.addEventListener('click',event => {if(!this.contains(event.target))this.close(false);},opts);
      document.addEventListener('pfs-share-open',event => {if(event.detail!==this)this.close(false);},opts);
      document.addEventListener('keydown',event => {
        if(event.key==='Escape'&&!this.menu.hidden){event.preventDefault();this.close(true);}
      },opts);
      this.menu.addEventListener('keydown',event => {
        const items=Array.from(this.menu.querySelectorAll('[role="menuitem"]'));
        const index=items.indexOf(document.activeElement);
        let next;
        if(event.key==='ArrowDown')next=(index+1)%items.length;
        if(event.key==='ArrowUp')next=(index-1+items.length)%items.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=items.length-1;
        if(next!==undefined){event.preventDefault();items[next].focus();}
      },opts);
      this.addEventListener('focusout',()=>setTimeout(()=>{if(!this.contains(document.activeElement))this.close(false);},0),opts);
      this.phone.addEventListener('change',()=>{
        if(this.menu.hidden)return;
        const channel=document.activeElement?.dataset.channel;
        this.buildMenu();this.placeMenu();
        if(channel)(this.menu.querySelector('[data-channel="'+channel+'"]')||this.menu.querySelector('[role="menuitem"]')).focus({preventScroll:true});
      },opts);
    }
    link(channel) {
      const url=new URL(this.dataset.shareUrl);
      const legacy=this.dataset.channelInMedium==='true';
      const tracking=legacy?{utm_source:'share',utm_medium:channel,utm_campaign:this.dataset.shareCampaign}:{utm_source:'share',utm_medium:'social',utm_campaign:this.dataset.shareCampaign,utm_content:channel};
      for(const [key,value] of Object.entries(tracking))url.searchParams.set(key,value);
      return url.href;
    }
    channelUrl(channel) {
      const e=encodeURIComponent,title=this.dataset.shareTitle,text=this.dataset.shareText||title,url=this.link(channel);
      if(channel==='facebook')return 'https://www.facebook.com/sharer/sharer.php?u='+e(url);
      if(channel==='x')return 'https://x.com/intent/post?text='+e(text)+'&url='+e(url);
      if(channel==='pinterest')return 'https://www.pinterest.com/pin/create/button/?url='+e(url)+'&media='+e(this.dataset.shareImage)+'&description='+e(text);
      if(channel==='email')return 'mailto:?subject='+e(title)+'&body='+e(text+'\n\n'+url);
      return 'sms:?&body='+e(text+' '+url);
    }
    buildMenu() {
      const channels=this.phone.matches?['sms','facebook','pinterest','email','native','copy']:['facebook','x','pinterest','email','copy'];
      const labels={sms:'Text message',facebook:'Facebook',x:'X',pinterest:'Pinterest',email:'Email',native:'More options',copy:'Copy link'};
      const colors={sms:'#34c759',facebook:'#1877f2',x:'#000',pinterest:'#e60023',email:'#6b5a43',native:'#8a7a62',copy:'#3a3a3a'};
      const ICON={x:'<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M17.8 3h3.1l-6.8 7.8L22 21h-6.2l-4.9-6.4L5.3 21H2.2l7.3-8.3L2 3h6.4l4.4 5.8L17.8 3zm-1.1 16.2h1.7L7.4 4.7H5.6l11.1 14.5z"/></svg>',more:'<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><circle cx="5" cy="12" r="2.2"/><circle cx="12" cy="12" r="2.2"/><circle cx="19" cy="12" r="2.2"/></svg>',sms:'<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 3C6.5 3 2 6.6 2 11c0 2.4 1.3 4.6 3.4 6.1L4.6 21l4.2-2.2c1 .3 2.1.4 3.2.4 5.5 0 10-3.6 10-8s-4.5-8.2-10-8.2z"/></svg>',fb:'<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M14 8h3V4h-3c-2.8 0-4.5 1.8-4.5 4.6V11H7v4h2.5v9h4v-9h3l.5-4h-3.5V8.8c0-.5.3-.8.5-.8z"/></svg>',pin:'<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 2a10 10 0 0 0-3.6 19.3c-.1-.8-.2-2 0-2.9l1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.5 1.8-2.5.9 0 1.3.7 1.3 1.4 0 .9-.6 2.2-.9 3.4-.2 1 .5 1.9 1.6 1.9 1.9 0 3.3-2 3.3-4.9 0-2.5-1.8-4.3-4.5-4.3-3 0-4.8 2.3-4.8 4.6 0 .9.4 1.9.8 2.4.1.1.1.2.1.3l-.3 1.2c0 .2-.2.3-.4.2-1.4-.6-2.2-2.6-2.2-4.2 0-3.4 2.5-6.6 7.2-6.6 3.8 0 6.7 2.7 6.7 6.3 0 3.7-2.4 6.8-5.6 6.8-1.1 0-2.2-.6-2.5-1.3l-.7 2.6c-.2.9-.9 2.1-1.4 2.8A10 10 0 1 0 12 2z"/></svg>',mail:'<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>',copy:'<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/></svg>'};
      const icons={sms:ICON.sms,facebook:ICON.fb,x:ICON.x,pinterest:ICON.pin,email:ICON.mail,native:ICON.more,copy:ICON.copy};
      const items=this.querySelector('.pfs-share-items');items.replaceChildren();
      channels.forEach(channel=>{
        const action=channel==='native'||channel==='copy',item=document.createElement(action?'button':'a');
        item.className='pfs-share-item';item.setAttribute('role','menuitem');item.dataset.channel=channel;
        if(action)item.type='button';else{item.href=this.channelUrl(channel);if(['facebook','x','pinterest'].includes(channel)){item.target='_blank';item.rel='noopener';}}
        const icon=document.createElement('span');icon.className='pfs-share-icon';icon.style.setProperty('--pfs-share-icon-color',colors[channel]);icon.setAttribute('aria-hidden','true');icon.innerHTML=icons[channel];
        const text=document.createElement('span');text.textContent=labels[channel];item.append(icon,text);
        item.addEventListener('click',()=>{if(channel==='copy')this.copy();else if(channel==='native')this.nativeShare();else this.close(false);});items.append(item);
      });
    }
    open(keyboard) {
      if(!this.menu.hidden){if(keyboard)this.menu.querySelector('[role="menuitem"]').focus({preventScroll:true});return;}
      document.dispatchEvent(new CustomEvent('pfs-share-open',{detail:this}));
      this.buildMenu();this.menu.hidden=false;this.trigger.setAttribute('aria-expanded','true');
      this.layers=[];let ancestor=this;
      while(ancestor&&ancestor!==document.body){this.layers.push(ancestor);ancestor.classList.add('pfs-share-layer-open');if(ancestor.classList.contains('shopify-section'))break;ancestor=ancestor.parentElement;}
      this.placementController=new AbortController();
      const opts={signal:this.placementController.signal,passive:true};
      const schedule=()=>{
        if(this.placementFrame)return;
        this.placementFrame=requestAnimationFrame(()=>{this.placementFrame=0;this.placeMenu();});
      };
      document.addEventListener('scroll',schedule,{...opts,capture:true});
      window.addEventListener('resize',schedule,opts);
      window.addEventListener('orientationchange',schedule,opts);
      window.visualViewport?.addEventListener('resize',schedule,opts);
      window.visualViewport?.addEventListener('scroll',schedule,opts);
      // Images and review widgets can reflow after the resize event itself.
      this.layoutObserver=new ResizeObserver(schedule);
      [document.body,this,this.menu,...document.querySelectorAll('sticky-header,.section-header')].forEach(el=>this.layoutObserver.observe(el));
      this.placeMenu(true);
      if(keyboard)this.menu.querySelector('[role="menuitem"]').focus({preventScroll:true});
    }
    screenBounds() {
      const viewport=window.visualViewport;
      const left=viewport?.offsetLeft||0,top=viewport?.offsetTop||0;
      const right=left+(viewport?.width||document.documentElement.clientWidth);
      const bottom=top+(viewport?.height||window.innerHeight);
      let headerBottom=top;
      // Measure visible sticky/fixed header ancestors, including an announcement offset.
      const headers=new Set();
      document.querySelectorAll('header,sticky-header,[role="banner"],.section-header').forEach(header=>{
        for(let el=header;el&&el!==document.body;el=el.parentElement)headers.add(el);
      });
      headers.forEach(el=>{
        const style=getComputedStyle(el),rect=el.getBoundingClientRect();
        if((style.position==='sticky'||style.position==='fixed')&&style.visibility!=='hidden'&&rect.width&&rect.height&&rect.bottom>top&&rect.top<bottom){
          headerBottom=Math.max(headerBottom,Math.min(rect.bottom,bottom));
        }
      });
      return {left:left+16,right:right-16,top:headerBottom+8,bottom:bottom-8};
    }
    placeMenu(allowScroll=false) {
      if(this.menu.hidden)return;
      const bounds=this.screenBounds(),button=this.trigger.getBoundingClientRect(),host=this.getBoundingClientRect();
      const availableHeight=Math.max(0,bounds.bottom-bounds.top);
      this.menu.style.maxHeight=availableHeight+'px';
      this.menu.style.maxWidth=Math.max(0,bounds.right-bounds.left)+'px';
      const menu=this.menu.getBoundingClientRect(),gap=10;
      const below=bounds.bottom-button.bottom-gap,above=button.top-gap-bounds.top;
      const down=menu.height<=below||(menu.height>above&&below>=above);
      const idealTop=down?button.bottom+gap:button.top-gap-menu.height;
      const top=Math.max(bounds.top,Math.min(idealTop,bounds.bottom-menu.height));
      const left=Math.max(bounds.left,Math.min(button.right-menu.width,bounds.right-menu.width));
      this.dataset.placement=down?'down':'up';
      this.menu.style.top=(top-host.top)+'px';
      this.menu.style.left=(left-host.left)+'px';
      this.menu.style.right='auto';
      // Clamp immediately, then move only the missing distance on opening. Scroll
      // events reposition without starting another scroll or fighting the reader.
      if(allowScroll&&menu.height>below&&menu.height>above){
        const distance=idealTop-top;
        if(Math.abs(distance)>1)window.scrollBy({top:distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    close(focus) {
      if(!this.menu)return;
      this.placementController?.abort();this.placementController=null;
      this.layoutObserver?.disconnect();this.layoutObserver=null;
      cancelAnimationFrame(this.placementFrame);this.placementFrame=0;
      this.menu.hidden=true;this.trigger.setAttribute('aria-expanded','false');
      (this.layers||[]).forEach(el=>el.classList.remove('pfs-share-layer-open'));this.layers=[];
      if(focus)this.trigger.focus({preventScroll:true});
    }
    announce(text) {
      clearTimeout(this.statusTimer);this.status.textContent=text;this.status.hidden=false;
      this.statusTimer=setTimeout(()=>{this.status.hidden=true;},5000);
    }
    async copy() {
      try {
        if(navigator.clipboard&&navigator.clipboard.writeText)await navigator.clipboard.writeText(this.link('copy'));
        else {const input=document.createElement('textarea');input.value=this.link('copy');input.style.cssText='position:fixed;top:0;left:0;opacity:0';this.append(input);input.select();let copied;try{copied=document.execCommand('copy');}finally{input.remove();}if(!copied)throw new Error('Copy unavailable');}
        this.close(true);this.announce(this.dataset.copiedLabel);
      }catch(error){this.announce('Could not copy. Please try again.');}
    }
    async nativeShare() {
      if(!navigator.share){this.announce('Sharing is unavailable in this browser. Choose a channel.');return;}
      try{await navigator.share({title:this.dataset.shareTitle,text:this.dataset.shareText||this.dataset.shareTitle,url:this.link('native')});this.close(true);}
      catch(error){if(error.name!=='AbortError')this.announce('Could not open sharing. Choose a channel.');}
    }
    disconnectedCallback(){this.close(false);this.controller?.abort();this.controller=null;clearTimeout(this.statusTimer);}
  }
  customElements.define('pfs-share-card',PfsShareCard);
}
  } catch(e) { console.error(e); }
})();

})();
